import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { resolveChatMessagingUiEnabled, whenAccessFeaturesReady } from '@/shared/composables/user-features'

/** Имя роута настроек языка — совпадает с subLink.name в settings-links-map. */
export const LANGUAGE_SETTINGS_ROUTE_NAME = 'languageSettings'

/**
 * Настройки чата — только полный UC.
 * Без IM редирект на язык, чтобы не открывалась пустая страница.
 * Персональные настройки (тема) этим guard не закрываем —
 * тема нужна без InstantMessaging и при webSoftphoneEnabled=false.
 */
export const chatSettingsBeforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  await whenAccessFeaturesReady()
  if (!resolveChatMessagingUiEnabled()) {
    next({ name: LANGUAGE_SETTINGS_ROUTE_NAME })
    return
  }
  next()
}
